import { MotionValue, motion, useTransform } from "motion/react";

export const ProgressBar = ({
  percent,
}: {
  percent: MotionValue<number>; // value between 0 & 100
}) => {
  const width = useTransform(() => `${percent.get()}%`);

  return (
    <div className="relative h-1 w-[100px] rounded-full bg-neutral-cream/30">
      <motion.div
        className="h-full bg-neutral-cream rounded-full"
        style={{ width }}
      />
    </div>
  );
};
